export * from './TechPcDesktopIcon';
export * from './TechPcDesktopIcon16Light';
export * from './TechPcDesktopIcon16Regular';
export * from './TechPcDesktopIcon16Solid';
export * from './TechPcDesktopIcon20Light';
export * from './TechPcDesktopIcon20Regular';
export * from './TechPcDesktopIcon20Solid';
export * from './TechPcDesktopIcon24Regular';
export * from './TechPcDesktopIcon24Solid';
export * from './TechPcDesktopIcon32Regular';
export * from './TechPcDesktopIcon64Regular';
